module.exports = __webpack_public_path__ + "img/relevant.9323a07e.png";